import React, { FunctionComponent } from 'react';
import Theme from '../../theme';

interface IProps {
  containerStyle?: {
    height?: string | number,
    width?: string | number,
    backgroundColor?: string,
    marginTop?: number,
    marginBottom?: number,
    marginLeft?: number,
    marginRight?: number,
    margin?: number,
  };
}

const SCREEN_WIDTH = window.innerWidth;

export const SkeletonLoader: FunctionComponent<IProps> = (props) => (
  <div className={'skeleton-loader'} style={{...styles.container, ...props.containerStyle}} />
);

const styles = {
  container: {
    width: SCREEN_WIDTH,
    height: '8em',
    backgroundColor: Theme.WHITE,
    overflow: 'hidden',
    borderRadius: '3px',
  },
};
